import React, { useState } from "react";
import Stat from "../../components/Stat";
import { money } from "../../utils/format";

// Partner programme on a franchise partner's Overview: partner rate (or free websites left), commission earned and the demo stores to
// share with their referral code (shops that sign up through these links become this partner's customers)
export default function PartnerCard({ stats, notify }) {
  const [copied, setCopied] = useState("");
  const { allowance, commission, shareLinks = [], referralCode, partnerRate } = stats;
  if (!allowance || !commission) return null;

  const copy = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(url);
    } catch {
      notify("Could not copy. Select the link and copy it yourself.", "error");
    }
  };
  const whatsapp = (link) => `https://wa.me/?text=${encodeURIComponent(`See this ${link.name} online store. You can get a website like this for your shop, free to start: ${link.url}`)}`;

  return (
    <>
      <div className="stats-grid">
        {/* Free websites only when the Super Admin gave some; otherwise the partner rate websites are bought at */}
        {allowance.allowance > 0 ? (
          <Stat label="Free websites left" value={allowance.left} meta={`${allowance.used} of ${allowance.allowance} used`} icon="◉" warn={allowance.left === 0} />
        ) : partnerRate && (
          <Stat label="Partner rate" value={money(partnerRate.price)} meta={`Per website / month, minimum ${partnerRate.minQuantity} (${money(partnerRate.price * partnerRate.minQuantity)})`} icon="▦" />
        )}
        <Stat label="Commission earned" value={money(commission.earned)} meta={`${commission.percent}% of ${money(commission.sales)} paid plans`} icon="₹" />
        <Stat label="Paid plans sold" value={commission.payments} meta="By your customers" icon="↗" />
        <Stat label="Referral code" value={referralCode} meta="Kept on every link you share" icon="⌁" />
      </div>
      {shareLinks.length > 0 && (
        <section className="panel partner-links">
          <div className="panel-heading">
            <div>
              <h2>Share demo stores</h2>
              <p>Send these links to shop owners. Anyone who signs up from them becomes your customer.</p>
            </div>
          </div>
          <div className="partner-link-grid">
            {shareLinks.map((link) => (
              <div className="partner-link" key={link.url}>
                <b>{link.name}</b>
                <code>{link.url}</code>
                <div>
                  <button className="outline-btn" onClick={() => copy(link.url)}>{copied === link.url ? "✓ Copied" : "Copy link"}</button>
                  <a className="primary-btn" href={whatsapp(link)} target="_blank" rel="noopener noreferrer">WhatsApp</a>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
